<template>
  <div class="box" style="position:relative;">
    <div class="overlay" v-if="showSpinner">
      <i class="fa fa-spinner fa-spin"></i>
    </div> 
    <div class="table-responsive">
      <table class="table table-striped">
        <tbody>
          <tr>
            <th>Fecha</th>
            <th>Pedido #</th>
            <th>Proyecto</th>
            <th>Items</th>
            <th>Cantidad</th>
            <th>Unidad</th>
            
            <th>Solicitado</th>
            <th v-if="tabla === 'aprobados' || tabla === 'comprados' || tabla === 'completado'">Validado</th>
            <th>Estado</th>
            <th v-if="tabla === 'comprados' || tabla === 'completado'">#OC</th>
            <th v-if="tabla === 'comprados' || tabla === 'completado'">Comprado</th>
            <th>Acciones</th>
          </tr>
          <tr v-for="(item,index) in registros" :key="item.id">
            <td :class="{'td-click': tabla === 'solicitados'}" @click="editar(item, index)">{{ item.createdAt | dateFormat}}</td>
            <td :class="{'td-click': tabla === 'solicitados'}" @click="editar(item, index)">
              #{{ item.pedido_id | pad(13) }}
            </td>
            <td :class="{'td-click': tabla === 'solicitados'}" @click="editar(item, index)">{{ item.codigo_proyecto }}</td>
            <td :class="{'td-click': tabla === 'solicitados'}" @click="editar(item, index)">{{ item.item_descripcion }}</td>
            <td :class="{'td-click': tabla === 'solicitados'}" @click="editar(item, index)">{{ item.qty }}</td>
            <td :class="{'td-click': tabla === 'solicitados'}" @click="editar(item, index)">{{ item.unidad_medida }}</td>
            
            <td :class="{'td-click': tabla === 'solicitados'}" @click="editar(item, index)">{{ item.solicitado_user }}</td>
            <td :class="{'td-click': tabla === 'solicitados'}" @click="editar(item, index)" v-if="tabla === 'aprobados' || tabla === 'comprados' || tabla === 'completado'">{{ item.validado_user }}</td>
            <td :class="{'td-click': tabla === 'solicitados'}" @click="editar(item, index)" >{{ item.estado }}</td>
            <td :class="{'td-click': tabla === 'solicitados'}" @click="editar(item, index)" v-if="tabla === 'comprados' || tabla === 'completado'">{{ item.id_orden_compra }}</td>
            <td :class="{'td-click': tabla === 'solicitados'}" @click="editar(item, index)" v-if="tabla === 'comprados' || tabla === 'completado'">{{ item.comprado_user }}</td>
            <td class="td-acciones">
              <template v-if="solapa === 'enprogreso'">
                <template v-if="tabla === 'solicitados'">
                  <a v-if="puedeHacerAccion(rolesPendienteAAprobado)" href="javascript:void(0)" class="btn btn-xs text-success" @click="acciones('aprobar', item, index)"><i class="fa fa-check"></i> Aprobar</a>
                  <a v-if="puedeHacerAccion(rolesPendienteARechazado)" href="javascript:void(0)" class="btn btn-xs text-danger" @click="acciones('rechazar', item, index)"><i class="fa fa-times"></i> Rechazar</a>
                </template>
                <template v-if="tabla === 'aprobados'">
                  <input  v-if="puedeHacerAccion(rolesCompras)" type="text" :name="'oc_' + index" v-model="item.id_orden_compra" class="input input-xs" placeholder="OC#" @keyup.enter="acciones('comprar', item)">
                  <a v-if="puedeHacerAccion(rolesCompras)" href="javascript:void(0)" class="btn btn-xs text-success" @click="acciones('comprar', item)"><i class="fa fa-check"></i> Comprar</a>                  
                  <a v-if="puedeHacerAccion(rolesCompras)" href="javascript:void(0)" class="btn btn-xs text-danger" @click="acciones('rechazar', item, index)"><i class="fa fa-times"></i> Rechazar</a>
                </template>
                <template v-if="tabla === 'comprados'">
                  <a v-if="puedeHacerAccion(rolesCompradoARecibido)" href="javascript:void(0)" class="btn btn-xs text-success" @click="acciones('completar', item, index)"><i class="fa fa-check"></i> Recibido</a>
                  <a v-if="puedeHacerAccion(rolesCompradoACancelado)" href="javascript:void(0)" class="btn btn-xs text-danger" @click="acciones('cancelar', item, index)"><i class="fa fa-times"></i> Cancelar</a>                  
                </template>
              </template>
              <template v-if="solapa === 'completado'">
                  <a v-if="puedeHacerAccion(rolesRechazadoAArchivado) && item.estado === 'Rechazado'" href="javascript:void(0)" class="btn btn-xs text-danger" @click="acciones('archivar', item, index)"><i class="fa fa-times"></i> Archivar</a>                
              </template>
              <template v-if="solapa === 'archivo'">
                  <a v-if="puedeHacerAccion(rolesArchivadoAPendiente)" href="javascript:void(0)" class="btn btn-xs text-primary"  @click="acciones('pendiente', item, index)"><i class="fa fa-pause"></i> Pendiente</a>                
              </template>              
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <paginate
      v-show="paginado.total > 0"
      v-model="paginado.pagina_actual"
      :page-count="paginado.paginas"
      :click-handler="cambiarPagina"
      :container-class="'pagination pagination-sm'"
    >
    </paginate>    
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate'
import {dateFormat} from '../../../filters/date'
import {pad} from '../../../filters/string'
export default {
  name: 'TablaCompra',
  components: {
    Paginate
  },
  props: {
    solapa: {
      type: String,
      default () {
        return 'enprogreso'
      }
    },
    tabla: {
      type: String,
      default () {
        return 'solicitados'
      }
    },
    data: {
      type: [Array, Promise],
      default () {
        return []
      }
    },
    total: {
      type: Number,
      default: 0
    },
    regPagina: {
      type: Number,
      default: 10
    },
    paginaActual: {
      type: Number,
      default: 0
    },
    cargando: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    dateFormat,
    pad
  },
  data () {
    return {
      showSpinner: this.cargando,
      registros: this.data,
      paginado: {
        total: 0,
        paginas: 1,
        pagina_actual: this.paginaActual,
        reg_pagina: this.regPagina
      },
      rolesEditar: ['root', 'manager', 'jefe_de_obras', 'coordinador', 'empleado', 'supervisor'],
      rolesCompradoARecibido: ['root', 'manager', 'jefe_de_obras', 'coordinador', 'empleado', 'supervisor'],
      rolesCompradoACancelado: ['root', 'compras'],
      rolesPendienteAAprobado: ['root', 'manager', 'jefe_de_obras', 'coordinador'],
      rolesPendienteARechazado: ['root', 'manager', 'jefe_de_obras', 'coordinador'],
      rolesRechazadoAArchivado: ['root', 'manager', 'jefe_de_obras', 'coordinador'],
      rolesArchivadoAPendiente: ['root', 'manager', 'jefe_de_obras', 'coordinador'],
      rolesCompras: ['root', 'compras']
    }
  },
  mounted () {
  },
  methods: {
    cambiarPagina (pag) {
      this.$emit('compras:filtar', pag, this.solapa, this.tabla)
    },
    editar (item, index) {
      if (this.tabla === 'solicitados' && this.puedeHacerAccion(this.rolesEditar)) {
        item.index_solicitado = index
        this.acciones('editar', item, index, 'solicitados', 'enprogreso')
      }
    },
    acciones (nombre, item, index) {
      this.$emit('compras:acciones', nombre, item, index, this.tabla, this.solapa)
    },
    puedeHacerAccion (roles) {
      return roles.indexOf(this.$store.state.user.role.type) > -1
    }
  },
  watch: {
    data: function (a) {
      this.registros = a
    },
    total: function (a) {
      this.paginado.total = a
      this.paginado.paginas = Math.ceil(a / this.paginado.reg_pagina)
    },
    regPagina: function (a) {
      this.paginado.reg_pagina = a
    },
    paginaActual: function (a) {
      this.paginado.pagina_actual = a
    },
    cargando: function (a) {
      this.showSpinner = a
    }
  }
}
</script>
<style scoped>
.td-acciones {
  white-space: nowrap;
}
.td-acciones input {
  max-width: 80px;
  text-align: center;
}
.td-click {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/views/compras/TablaCompra.vue